import { useSetWorkspaceFilter, useWorkspaceFilter } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const WorkspacesSearchInput = () => {
  const { t } = useTranslation();
  const { data: filter } = useWorkspaceFilter();
  const { mutateAsync } = useSetWorkspaceFilter();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('workspace.filter.searchPlaceholder')}
    />
  );
};
